import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReviewAssessScreenComponent } from '../../../components/review-content/review-assess-screen/review-assess-screen.component';
import { CommonModule } from '@angular/common';
import { IAssessScreen } from '../../../../shared/models/assessScreen';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'evaluation-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewAssessScreenComponent
  ],
  templateUrl: './evaluation-submission.component.html',
  styleUrl: './evaluation-submission.component.css'
})
export class EvaluationSubmissionComponent implements OnInit {

  currentCaseId: string | null = null;
  submitForm: FormGroup = new FormGroup({});
  @Output() onSaveSection5 = new EventEmitter<IAssessScreen>();

  constructor(
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
  }

  submitAssessment(): void {
    this.onSaveSection5.emit(this.submitForm.value);
  }
}
